import { MyWritingPage } from '@features/myWriting/pages/MyWritingPage'
import { withAuthenGuard } from '@lib/hoc/withAuthenGuard'
import { AppLayout } from '@components/layouts/AppLayout'
import { maintenanceHandler } from '@lib/maintenanceHandler'

function MyWriting() {
  return (
    <AppLayout>
      <MyWritingPage />
    </AppLayout>
  )
}

export const getServerSideProps = async () => {
  return maintenanceHandler()
}

export default withAuthenGuard(MyWriting)
